<template>
  <div>
    <div>
      <div class="fist_row" :style="{ backgroundColor: bgColor }">
        <img style="cursor:pointer;margin-left: 50px"
          src="https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/cloudstorage/logo/logo_transport-min.png"
          alt @click="navigateToHome" />
        <nav class="navbar">
          <ul>
            <li>
              <router-link :to="{ name: 'About', params: { index: 0 } }" style="font-size: 18px;"
                :class="{ 'active-nav-item': isActiveAbout }">{{
                  $t('messages.aboutUs') }}</router-link>
              <ul>
                <li>
                  <router-link :to="{ name: 'About', params: { index: 0 } }" style="font-size: 14px;">{{
                    $t('messages.companyProfile') }}</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'About', params: { index: 1 } }" style="font-size: 14px;">{{
                    $t('messages.management') }}</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'About', params: { index: 2 } }" style="font-size: 14px;">{{
                    $t('messages.about') }}</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'About', params: { index: 3 } }" style="font-size: 14px;">{{
                    $t('messages.historyAwards') }}</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'About', params: { index: 4 } }" style="font-size: 14px;">{{
                    $t('messages.certification') }}</router-link>
                </li>
              </ul>
            </li>
            <li>
              <router-link to="/events" style="font-size: 18px;" :class="{ 'active-nav-item': isActiveEvents }">{{
                $t('messages.events') }}</router-link>
              <!-- <ul>
                <li>
                  <router-link to="/products" style="font-size: 14px;">{{ $t('messages.companyNews') }}</router-link>
                </li>
                <li>
                  <router-link to="/products" style="font-size: 14px;">{{ $t('messages.industryNews') }}</router-link>
                </li>
              </ul> -->
            </li>
            <li>
              <router-link to="/products" style="font-size: 18px;" :class="{ 'active-nav-item': isActiveProducts }">{{
                $t('messages.products') }}</router-link>
              <ul>
                <!-- 增加二级子菜单 -->
                <li>
                  <el-collapse v-model="activeName" accordion>
                    <el-collapse-item :title="$t('messages.pogopinProbe')" name="1" class="sub-menu-item">
                      <router-link :to="{ name: 'Pogopin_Probes', query: { type: 10 } }">{{ $t('messages.pogpinSingle')
                        }}</router-link>
                      <router-link :to="{ name: 'Pogopin_Probes', query: { type: 11 } }">{{
                        $t('messages.pogopinConnector') }}</router-link>
                      <router-link :to="{ name: 'Pogopin_Probes', query: { type: 12 } }">{{
                        $t('messages.pogopinWaterpoofConnector')
                      }}</router-link>
                      <router-link :to="{ name: 'Pogopin_Probes', query: { type: 13 } }">{{
                        $t('messages.pogopinMagneticConnector')
                      }}</router-link>
                    </el-collapse-item>
                    <el-collapse-item :title="$t('messages.TestingProbes')" name="2">
                      <router-link :to="{ name: 'TestingProbes', query: { type: 20 } }">{{ $t('messages.ictProbe')
                        }}</router-link>
                      <router-link :to="{ name: 'TestingProbes', query: { type: 21 } }">{{ $t('messages.icProbe')
                        }}</router-link>
                      <router-link :to="{ name: 'TestingProbes', query: { type: 22 } }">{{
                        $t('messages.highCurrentTestProbe')
                      }}</router-link>
                    </el-collapse-item>
                    <el-collapse-item :title="$t('messages.connectors')" name="3">
                      <router-link :to="{ name: 'IndustryConnector', query: { type: 30 } }">{{
                        $t('messages.pinSocketTerminal')
                      }}</router-link>
                      <router-link :to="{ name: 'IndustryConnector', query: { type: 31 } }">{{
                        $t('messages.roundConnector')
                      }}</router-link>
                      <router-link :to="{ name: 'IndustryConnector', query: { type: 32 } }">{{
                        $t('messages.rectangularConnector')
                      }}</router-link>
                    </el-collapse-item>
                    <el-collapse-item :title="$t('messages.MetalParts')" name="4">
                      <router-link :to="{ name: 'HardwareComponents', query: { type: 40 } }">{{
                        $t('messages.communicationShaftParts')
                      }}</router-link>
                      <router-link :to="{ name: 'HardwareComponents', query: { type: 41 } }">{{
                        $t('messages.medicalDeviceShaftParts')
                      }}</router-link>
                      <router-link :to="{ name: 'HardwareComponents', query: { type: 42 } }">{{
                        $t('messages.aerospaceComplexParts')
                      }}</router-link>
                    </el-collapse-item>
                  </el-collapse>
                </li>

              </ul>
            </li>
            <li>
              <router-link to="/markets" style="font-size: 18px;" :class="{ 'active-nav-item': isActiveMarkets }">{{
                $t('messages.markets') }}</router-link>
              <ul>
                <li>
                  <router-link to="/markets">{{ $t('messages.titleConsumerElectronics') }}</router-link>
                </li>
                <li>
                  <router-link to="/markets">{{
                    $t('messages.titleTesting') }}</router-link>
                </li>
                <li>
                  <router-link to="/markets">{{
                    $t('messages.titleIndustrial') }}</router-link>
                </li>
                <li>
                  <router-link to="/markets">{{
                    $t('messages.titleNewEnergy') }}</router-link>
                </li>
                <li>
                  <router-link to="/markets">{{
                    $t('messages.titleMedical') }}</router-link>
                </li>
                <li>
                  <router-link to="/markets">{{
                    $t('messages.titleComunication') }}</router-link>
                </li>
              </ul>
            </li>
            <li>
              <router-link :to="{ name: 'Contact', params: { index: 0 } }" style="font-size: 18px;"
                :class="{ 'active-nav-item': isActiveContact }">{{
                  $t('messages.contactUs') }}</router-link>
              <ul>
                <li>
                  <router-link :to="{ name: 'Contact', params: { index: 0 } }">{{
                    $t('messages.addrTitle') }}</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'Contact', params: { index: 1 } }">{{
                    $t('messages.moreInfoTitle') }}</router-link>
                </li>
                <!-- <li>
                  <router-link :to="{ name: 'Contact', params: { index: 2 } }">{{
                    $t('messages.moreInfoTitle') }}</router-link>
                </li> -->
              </ul>
            </li>
          </ul>
        </nav>
        <div :class="{ hidden: shouldShow }">
          <el-input :placeholder="$t('messages.searchPlaceholder')" maxlength="10" v-model="searchText"
            class="search_input">
            <el-button slot="append" icon="el-icon-search" @click="gotoSearchList"></el-button>
          </el-input>
        </div>
        <div class="language_container">
          <el-dropdown @command="handleCommand" style="margin-right: 20px;">
            <span style="color: white;">
              {{ dropDownTitle }}
              <i class="el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">中文</el-dropdown-item>
              <el-dropdown-item command="b">English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!-- <div class="video-container">
          <video src="static/leeno/231128-Leeno-05.mp4" autoplay muted loop playsinline></video>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  props: {
    // searchText: {
    //   type: String,
    //   default: ""
    // },
    bgColor: {
      type: String,
      default: "transparent"
    },
    shouldShow: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      searchText: '',
      activeName: '1',
      dropDownTitle: "中文",
      pogopinDisplayStyle: 'none' // 初始值为 'block'
    };
  },

  computed: {
    isActiveProducts() {
      return this.$route.path.startsWith("/products");
    },
    isActiveAbout() {
      return this.$route.path.startsWith("/about");
    },
    isActiveMarkets() {
      return this.$route.path.startsWith("/markets");
    },
    isActiveEvents() {
      return this.$route.path.startsWith("/events");
    },
    isActiveContact() {
      return this.$route.path.startsWith("/contact");
    },
    isActiveInvestors() {
      return this.$route.path.startsWith("/investors");
    },
    isActiveWhatWeDo() {
      return this.$route.path.startsWith("/whatWeDo");
    }
  },

  methods: {
    navigateToHome() {
      this.$router.push({ path: "/" }).then(() => {
        window.scrollTo(0, 0); // 回到页面顶部
      });
    },

    handleCommand(command) {
      if (command === "a") {
        this.dropDownTitle = "中文";
        this.$i18n.locale = 'zh';
      } else if (command === "b") {
        this.dropDownTitle = "English";
        this.$i18n.locale = 'en';
      }
    },

    toggleSubSubMenu(menuKey) {
      switch (menuKey) {
        case 'pogopin':
          this.pogopinDisplayStyle = this.pogopinDisplayStyle === 'block' ? 'none' : 'block';
          break;
        // 可以在这里添加更多的 case 来处理其他子菜单
      }
    },
    showSubMenu(menuKey) {
      switch (menuKey) {
        case 'pogopin':
          this.pogopinDisplayStyle = 'block';
          break;
        // 可以在这里添加更多的 case 来处理其他子菜单
      }
    },
    hideSubMenu(menuKey) {
      switch (menuKey) {
        case 'pogopin':
          this.pogopinDisplayStyle = 'none';
          break;
        // 可以在这里添加更多的 case 来处理其他子菜单
      }
    },

    gotoSearchList() {
      this.$router.push({ path: "/searchlist", query: { keyword: this.searchText } }).then(() => {
        // window.scrollTo(0, 0); // 回到页面顶部
      });
    },
  }
};
</script>

<style scoped>
.fist_row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: fixed;
  gap: 20px;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0);
  /* 使用rgba设置透明度 */
  color: #fff;
  /* 文字颜色 */
  z-index: 1000;
  /* 确保导航栏在视频之上 */
  /* margin-top: 50px; */
  padding-top: 30px;
  padding-bottom: 20px;
  align-items: center;
  max-width: 100vw;
}

/* .language_container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 50px;
} */

.fist_row img {
  font-size: 1rem;
  line-height: 1.5;
  /* font-family: "Poppins"; */
  color: #0077b4;
  box-sizing: inherit;
  border-style: none;
  display: block;
  width: 400px;
  height: 45px;
  max-width: unset;
}

.navbar ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.navbar li {
  float: left;
}

.navbar li a,
.navbar li ul {
  display: block;
  color: inherit;
  text-align: left;
  padding: 14px 16px;
  text-decoration: none;
}

/* 一级菜单项的悬停效果 */
.navbar>ul>li:hover>a {
  background-color: #0077b4;
  /* 当鼠标悬停时改变背景色 */
}

/* 一级菜单项默认样式 */
.navbar>ul>li>a {
  background-color: transparent;
  /* 明确设置背景色为透明 */
  border-radius: 15px;
  /* 圆角 */
  font-size: 14px;
  /* 字体大小 */
}

/* 子菜单项的悬停效果取消 */
.navbar li ul li a:hover {
  background-color: inherit;
  /* 继承父级的背景色，保持不变 */
  color: #0077b4;
  /* 当鼠标悬停时字体颜色 */
}

/* 子菜单样式 */
.navbar li:hover>ul {
  display: grid;
  /* 当鼠标悬停时显示子菜单 */
}

.navbar li ul {
  display: none;
  /* display: block; */
  /* 默认隐藏子菜单 */
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  /* 子菜单背景 */
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  /* width: max-content; */
}

/* 子菜单项的样式 */
.navbar li ul li {
  display: block;
  /* 子菜单项为块级元素，确保竖向排列 */
}

/* 子菜单项的文字颜色 */
.navbar li ul li a {
  color: #000;
  /* 子菜单文字颜色 */
  /* font-family: "Poppins", sans-serif; */
  font-size: 14px;
}

/* 清除浮动 */
.navbar:after {
  content: "";
  display: table;
  clear: both;
}

.navbar .active-nav-item {
  background-color: #0077b4;
  /* 激活链接的背景色 */
  color: #fff;
  /* 激活链接的文字颜色 */
}

.navbar a {
  /* font-family: "Poppins", sans-serif; */
}

.hidden {
  visibility: hidden;
}

.search_input {
  max-width: 190px;
  min-width: 150px;
}

/deep/ .el-collapse-item__wrap {
  border: none;
  background-color: transparent !important;
}



/deep/ .el-collapse-item__header {
  border: none;
  background-color: transparent !important;
}

/deep/ .el-collapse-item__header:hover {
  color: #0077b4 !important;
  /* background-color: transparent !important; */
}


/deep/ .el-collapse-item__content {
  /* color: #fff; */
  background-color: transparent !important;
}


/* .sub-menu-item {
  background-color: transparent;
} */


/* .navbar li ul ul {
  display: none;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
}

.navbar li ul ul li {
  display: block;
}

.navbar li ul ul li a {
  color: #000;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
} */
</style>


// WEBPACK FOOTER //
// src/components/NavBar.vue